export function getFileUrl(id: string): string {
  return `${import.meta.env.VITE_API_DOMAIN}/api/fs/file/${id}/download`;
}
